import { Link } from 'react-router-dom';
import { manhwaList } from '@/mocks/manhwa';

export default function FeaturedSection() {
  const featured = manhwaList.filter((m) => m.featured);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              编辑精选
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              精心挑选的高质量韩国漫画，每一部都值得一读
            </p>
          </div>
          <Link
            to="/category/lianai"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featured.slice(0, 5).map((manhwa) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-100">
                <img
                  src={manhwa.cover}
                  alt={manhwa.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {manhwa.categoryName}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-amber-400 text-xs"></i>
                    </div>
                    <span className="text-white text-xs font-medium">{manhwa.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {manhwa.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{manhwa.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}